module.exports = __webpack_public_path__ + "8c2ed911675cd6910b299fcdebef29d4.svg";